import { Row, Col, Input } from 'reactstrap';
import { Controller } from "react-hook-form";

const VariableRow = ({ variable, control, errors, handleInputChange }) => {
    return (
        <Row key={variable} className="mt-2 mb-4 align-items-center">
            <Col md={3} className="pr-0">
                <input 
                    type="text" 
                    id={`variable_input_${variable}`}
                    name={`variable_input_${variable}`}
                    disabled 
                    className="form-control text-center" 
                    value={`{{ ${variable} }}`} 
                />
            </Col>
            <Col md={9} className="pl-1">
                <div className="d-flex align-items-center">
                     <Controller
                        name={`variable_${variable}_fallback`}
                        control={control}
                        rules={{ required: "Add sample text" }}
                        render={({ field }) => (
                            <div className="w-100 position-relative">
                                <Input
                                    {...field}
                                    type="text"
                                    id={`variable_fallback_${variable}`}
                                    placeholder={`Enter content for {{${variable}}}`}
                                    className="mr-2"
                                    invalid={!!errors[`variable_${variable}_fallback`]}
                                    onChange={(e) => {
                                        field.onChange(e);
                                        handleInputChange(`variable_${variable}_fallback`, e.target.value);
                                    }}
                                />
                                {errors[`variable_${variable}_fallback`] && (
                                    <span className="text-danger note-text position-absolute" style={{bottom: '-20px', left: '0'}}>
                                        {errors[`variable_${variable}_fallback`].message}
                                    </span>
                                )}
                            </div>
                        )}
                    />
                </div>
            </Col>
        </Row>
    );
};

export default VariableRow;
